import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol viewBox=\"0 0 8 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back\">\n<path d=\"M7.3499 1.16304C7.56957 1.38271 7.56957 1.73887 7.3499 1.95854L2.31014 6.99829L7.3499 12.038C7.56957 12.2577 7.56957 12.6139 7.3499 12.8335C7.13023 13.0532 6.77407 13.0532 6.5544 12.8335L1.1169 7.39604C0.897231 7.17637 0.897231 6.82021 1.1169 6.60054L6.5544 1.16304C6.77407 0.943374 7.13023 0.943374 7.3499 1.16304Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol